<div class="mb-3 text-end" *ngIf="displaySelectableOptions">
    <button
        class="btn btn-link ps-0 py-0 pe-1"
        (click)="onSelectAllRecipientsChange(true)"
        translate="RECIPIENT_SELECT_ALL"
    ></button>
    <span class="line-separator">|</span>
    <button
        class="btn btn-link pe-0 py-0 ps-1"
        (click)="onSelectAllRecipientsChange(false)"
        translate="RECIPIENT_DESELECT_ALL"
    ></button>
</div>
<ng-container *ngIf="!cseEmail">
    <div class="col-10 col-sm-11">
        <p>{{ cseEmail }}</p>
    </div>
</ng-container>
<ng-container *ngFor="let recipient of model.value; index as i">
    <div class="row mb-3" *ngIf="!recipient.isHidden" [formGroup]="recipientForm">
        <div class="col-10 col-sm-11">
            <div *ngIf="!recipient.isEditable">{{ recipient.faxEmail.value }}</div>
            <pace-core-text-input
                *ngIf="recipient.isEditable"
                [(model)]="recipient.faxEmail"
                (valueChange)="updateRecipientStatus(i)"
                [parentForm]="recipientFormChildren"
                [ariaLabel]="('RECIPIENT_EMAIL_ARIA_LABEL' | translate) + (i + 1)"
            ></pace-core-text-input>
            <span
                class="error-text"
                *ngIf="isNgmP58 && isEmailInvalid(recipient)"
                translate="RECIPIENT_INVALID_EMAIL_ERROR_MESSAGE"
            >
            </span>
        </div>
        <div class="col-2 col-sm-1">
            <button
                class="btn btn-warning float-end"
                *ngIf="recipient.isDeletable"
                (click)="deleteRecipient(i)"
                [attr.aria-label]="('RECIPIENT_DELETE_EMAIL_ARIA_LABEL' | translate) + (i + 1)"
            >
                <fa-icon [icon]="faTrashAlt" class="fa-xs"></fa-icon>
            </button>
            <pace-core-checkbox-input
                *ngIf="!recipient.isDeletable"
                [(model)]="recipient.isSelected"
                [parentForm]="recipientFormChildren"
                (valueChange)="onSelectionChange(recipient)"
                class="float-end"
                [ariaLabel]="('RECIPIENT_SELECT_EMAIL_ARIA_LABEL' | translate) + (i + 1)"
            ></pace-core-checkbox-input>
        </div>
    </div>
</ng-container>
<div class="row mb-3">
    <div class="col">
        <button
            class="btn btn-primary"
            *ngIf="displaySubmitButton"
            [disabled]="recipientFormChildren.invalid || disableSubmit"
            (click)="submitToDataManagement()"
            translate="SEND_RECIPIENT_TO_DATA_MANAGEMENT"
        ></button>
    </div>
</div>

<button
    class="btn btn-primary float-end"
    [disabled]="model.value.length >= model.options.maxEntries"
    (click)="addRecipient()"
    translate="RECIPIENT_ADD"
></button>
